import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { IMaskPipe } from 'angular-imask';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import { provideRouter } from '@angular/router';

import { WINDOW_PROVIDERS } from '@protctc/common/core/services/window.service';
import { httpInterceptorProviders } from '@protctc/common/core/interceptors';
import { AuthService } from '@protctc/common/core/services/auth.service';
import { DEFAULT_DIALOG_HOST_PROVIDER, DialogsService } from '@protctc/common/shared/dialogs/dialogs.service';
import { FileUploadService } from '@protctc/common/core/services/file-upload';
import { S3UploadService } from '@protctc/common/core/services/s3-upload.service';

import { appRoutes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { CustomDateAdapter, CUSTOM_DATE_FORMATS } from './app/modules/shared/datepicker/custom-date-adapter';

bootstrapApplication(AppComponent, {
	providers: [
		provideZoneChangeDetection(),
		...WINDOW_PROVIDERS,
		...httpInterceptorProviders,
		AuthService,
		CurrencyPipe,
		DatePipe,
		IMaskPipe,
		DialogsService,
		DEFAULT_DIALOG_HOST_PROVIDER,
		{
			provide: FileUploadService,
			useClass: S3UploadService,
		},
		{
			provide: STEPPER_GLOBAL_OPTIONS,
			useValue: { displayDefaultIndicatorType: false },
		},
		{ provide: DateAdapter, useClass: CustomDateAdapter },
		{ provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
		provideHttpClient(withInterceptorsFromDi()),
		provideRouter(appRoutes),
	],
}).catch(err => console.error(err));
